/**
 * Whether this document is a secure credential link's public page (#12505).
 *
 * Read by the router (the page renders the same signed in or not) and by the
 * Sentry setup, which must never start on a page whose purpose is a secret.
 */
export const isSecureLinkPath = (): boolean =>
  window.location.pathname.startsWith("/s/");
